const reportStatusConverter = (status) => {
  switch (status) {
    case "draft":
      return "DRAFT";

    case "pending approver":
      return "PENDING";

    case "pending reimbursement":
      return {
        text: "Pending reimbursement",
        color: "yellow-01.main",
        bgColor: "light-yellow-01.main",
      };

    case "reimbursement complete":
      return "REIMBURSED";

    case "rejected":
      return "REJECTED";
    
    case "pending bank decision":
      return {
        text: "Pending bank decision",
        color: "yellow-01.main",
        bgColor: "light-yellow-01.main",
      }

    default:
      return "default";
  }
};

export default reportStatusConverter;
